import React from 'react';
import parse from 'html-react-parser';

/**
 * BannerSectionStyle9 — Used by Blog, BlogDetails, DoctorDetails pages (right-side image panel)
 */
export default function BannerSectionStyle9({ imgUrl, title, subTitle }) {
  return (
    <section className="relative min-h-[460px] flex items-center pt-[100px] pb-[80px] overflow-hidden bg-cream border-b border-[rgba(139,26,26,0.08)]">
      {/* Decorative left accent line */}
      <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-gradient-to-b from-transparent via-crimson to-transparent opacity-30" />

      <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-16 w-full grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

        {/* Text column */}
        <div className="flex flex-col justify-center">
          <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-5">
            <span className="w-[30px] h-px bg-gold block" />
            Noohra Integrated Services
          </div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] font-light leading-[1.15] text-charcoal mb-5">
            {parse(title || '')}
          </h1>
          {subTitle && (
            <p className="text-base leading-[1.8] text-mid font-light max-w-[480px] mb-0">
              {parse(subTitle)}
            </p>
          )}
        </div>

        {/* Image column */}
        {imgUrl && (
          <div className="hidden md:flex items-end justify-center">
            <img
              src={imgUrl}
              alt="Banner"
              className="max-h-[340px] w-auto object-contain drop-shadow-xl"
            />
          </div>
        )}
      </div>
    </section>
  );
}
